import MainService from "../Main";
import * as operations from "./Sitemap.graphql.js";

class SearchService extends MainService {
	constructor(options) {
		super(options);
		this.patch(operations);
	}

	getSitemap(variables = {}, options = {}) {
		return this.query(variables, options, "sitemap");
	}
}

export default SearchService;
